import { Injectable, inject } from '@angular/core';
import { TranslationService } from '@services/translation.service';

@Injectable({
  providedIn: 'root',
})
export class AppInitService {
  private translate = inject(TranslationService);

  constructor() {}

  async init(): Promise<void> {
    await this.translate.init();
  }
}
